export const EditableRegionTypeLookup = {
    EventData: 'EventData',
} as const
